import { useCallback } from "react";

export function useClickElement(
  iframeRef: React.RefObject<HTMLIFrameElement>,
  iframeOrigin: string,
  selectedSection: string | null,
  targetSectionId: string,
  elementId: string
) {
  const sectionId =
    selectedSection === targetSectionId ? targetSectionId : null;

  const clickElement = useCallback(
    () => {
      if (!sectionId) {
        return;
      }

      const payload: any = {
        type: "clickElement",
        elementId,
      };

      iframeRef.current?.contentWindow?.postMessage(payload, iframeOrigin);
    },
    [iframeRef, sectionId, elementId]
  );

  return { clickElement };
}